"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var CopyRegular = function CopyRegular(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "account",
    viewBox: "0 0 18 18"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-608.000000, -762.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("g", {
    transform: "translate(520.000000, 281.000000)"
  }, react_1["default"].createElement("g", {
    transform: "translate(88.000000, 481.000000)"
  }, react_1["default"].createElement("path", {
    d: "M15,4 C16.6568542,4 18,5.34314575 18,7 L18,15 C18,16.6568542 16.6568542,18 15,18 L7,18 C5.34314575,18 4,16.6568542 4,15 L6,15 C6,15.5128358 6.38604019,15.9355072 6.88337887,15.9932723 L7,16 L15,16 C15.5128358,16 15.9355072,15.6139598 15.9932723,15.1166211 L16,15 L16,7 C16,6.44771525 15.5522847,6 15,6 L15,4 Z M11,0 C12.6568542,-3.04359188e-16 14,1.34314575 14,3 L14,11 C14,12.6568542 12.6568542,14 11,14 L3,14 C1.34314575,14 2.02906125e-16,12.6568542 0,11 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L11,0 Z M11,2 L3,2 C2.48716416,2 2.06449284,2.38604019 2.00672773,2.88337887 L2,3 L2,11 C2,11.5128358 2.38604019,11.9355072 2.88337887,11.9932723 L3,12 L11,12 C11.5128358,12 11.9355072,11.6139598 11.9932723,11.1166211 L12,11 L12,3 C12,2.44771525 11.5522847,2 11,2 Z"
  }))))));
};

exports["default"] = CopyRegular;